import { CatHeading } from 'components/blocks-components';
import styles from '../../request-equipment-service.module.scss';
import cx from 'classnames';
import { CustomStyledLabel } from '@cat-ecom/pcc-components';
import { capitalizeText } from '@cat-ecom/common/utils/stringUtils';
import { RequestServicePartDetailsInfoProps } from 'components/request-equipment-service/types';

const RequestServicePartDetailsInfo = ({
  label,
  value,
  classname
}: Readonly<RequestServicePartDetailsInfoProps>) => {
  return (
    <div className={cx('row', classname)}>
      <div className="col-4 col-md-3 pe-2 pe-md-3 text-break">
        <CatHeading variant="body-sm">
          <CustomStyledLabel className={styles['request-service__font-color']}>
            {label}
          </CustomStyledLabel>
        </CatHeading>
      </div>
      <div
        className={cx([
          'col-8 col-md-9 text-break',
          styles['request-service__fw-semi-bold']
        ])}
      >
        <CatHeading variant="body-sm">
          <CustomStyledLabel>{capitalizeText(value)}</CustomStyledLabel>
        </CatHeading>
      </div>
    </div>
  );
};
export default RequestServicePartDetailsInfo;
